import axios from 'axios'
import { AxiosInstance } from 'axios/index'
import APIHeaders from '../entities/APIHeaders'

export default (header: APIHeaders): AxiosInstance | Error => {

  // 不要なAPIアクセスを防ぐためheaderのバリデーション
  if (!APIHeaders.isAPIHeaders(header)) {
    return Error('headerが作成できませんでした')
  }

  return axios.create({
    baseURL: process.env.VUE_APP_API_ORIGIN,
    // timeout: 1000,
    headers: header,
    validateStatus(status) {
      return status >= 200 && status < 300; // default
    },
    data: {},
  })
}
